import React from 'react';
import classnames from 'classnames';
import { map } from 'lodash';
import { Collapse } from '@mui/material';
import InspectorDefault from '../elements/schema-editor/schema-inspector/InspectorDefault';
import { RemoveIconButton } from 'new/elements/Button/RemoveIconButton';

class DefaultRecipeGroup extends React.PureComponent {
  render() {
    const { isReadOnly, isExpanded } = this.props;

    return (
      <>
        <Collapse in={isExpanded}>{this._renderDefaultGroup()}</Collapse>
        {!isReadOnly && (
          <button className="add-recipe-button" onClick={this._handleAddDefaultClicked}>
            + Add New Default
          </button>
        )}
      </>
    );
  }

  _renderDefaultGroup = () => {
    const { data, outputSchema, displayOptions, isReadOnly, isInteractive, onRecipeClicked } =
      this.props;

    if (isReadOnly) {
      return (
        <div className="schema-validations-editor">
          <ul className="filters-list">
            {map(data, (defaultData, index) => (
              <li
                key={index}
                className={classnames('filter-item is-blurred', {
                  'is-read-only': isReadOnly && !isInteractive,
                })}
                onClick={() => {
                  if (isReadOnly && isInteractive) {
                    onRecipeClicked(index);
                  }
                }}
              >
                <div className="left">
                  <h3>{defaultData.__destAttr}</h3>
                  <span className="schema-validation-rule-description">
                    <span className="attr-name">
                      {JSON.stringify(defaultData.parameters?.value)}
                    </span>
                  </span>
                </div>
              </li>
            ))}
          </ul>
        </div>
      );
    }

    return (
      <div className="transform-recipes">
        {map(data, (defaultData, index) => (
          <div key={index} className="default-recipe-element">
            <div className="left">
              <InspectorDefault
                defaultData={defaultData}
                outputSchema={outputSchema}
                displayOptions={displayOptions}
                isReadOnly={isReadOnly}
                onDefaultChanged={(newDefaultData) =>
                  this._handleAttributeDefaultChanged(newDefaultData, index)
                }
              />
            </div>
            <RemoveIconButton
              onClickRemove={(e) => {
                e.stopPropagation();
                this._handleDeleteDefaultClicked(index);
              }}
              tooltipText="Remove Rule"
              className="delete-icon"
            />
          </div>
        ))}
      </div>
    );
  };

  _handleAddDefaultClicked = () => {
    const { data, isExpanded, onExpand, onChangeRecipeGroup } = this.props;
    const newData = [
      ...data,
      {
        type: 'defaults',
        parameters: {
          defaultType: 'DEFAULT_NONE',
          value: null,
        },
        __destAttr: '',
      },
    ];

    if (!isExpanded) {
      onExpand();
    }

    onChangeRecipeGroup(newData);
  };

  _handleDeleteDefaultClicked = (index) => {
    const { data, onChangeRecipeGroup } = this.props;
    const newData = [...data];
    newData.splice(index, 1);

    onChangeRecipeGroup(newData);
  };

  _handleAttributeDefaultChanged = (defaultData, index) => {
    const { data, onChangeRecipeGroup } = this.props;
    const newData = [...data];
    newData[index] = defaultData;

    onChangeRecipeGroup(newData);
  };
}

export default DefaultRecipeGroup;
